'use client';

import LinkButton from '@carvana/ds-link-button';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { datadogRum } from '@datadog/browser-rum';
import { useRouter } from 'next/navigation';
import { useContext } from 'react';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';
import { DATADOG_EVENTS } from '~/constants/flp/datadogEvents';
import { useIsNative } from '~/context/common/DeviceContext';
import {
  useClosedAccountModal,
  useOpenAccountModal
} from '~/hooks/common/accountModal/useAccountModal';
import { LoginPromptText } from './Hero.styles';

export default function LoginPrompt() {
  const closedAccountModal = useClosedAccountModal();
  const isNative = useIsNative();
  const openAccountModal = useOpenAccountModal();
  const router = useRouter();
  const { trackEvent } = useContext(AnalyticsContext);

  if (isNative) {
    return null;
  }

  const handleSignInClick = () => {
    datadogRum.addAction(DATADOG_EVENTS.MARKETING.CLICKS_LOGIN_CTA);
    trackEvent(ANALYTICS_EVENTS.MARKETING.CLICKS_LOGIN_CTA);
    openAccountModal({
      onSuccess: () => {
        trackEvent(ANALYTICS_EVENTS.MARKETING.LOGIN_SUCCEEDED);
        closedAccountModal('submit');
        router.refresh();
      }
    });
  };

  return (
    <LoginPromptText data-testid="flp-login-prompt">
      Have an account?{' '}
      <LinkButton
        data-analytics-id="Financing Hero Sign In Link"
        data-testid="flp-login"
        underline={false}
        onClick={handleSignInClick}
      >
        Sign In
      </LinkButton>
    </LoginPromptText>
  );
}
